module.exports = __webpack_public_path__ + "static/media/laugh.debfecc5.svg";